function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomSizeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.945 21.292h-2.822l9.17-9.17v2.823h2V8.709h-6.238v2h2.823l-9.169 9.169v-2.822h-2v6.236h6.236v-2zm-9.236 5h20.583V5.709H5.709v20.583zM27.292 3.709H4.709a1 1 0 00-1 1v22.583a1 1 0 001 1h22.583a1 1 0 001-1V4.709a1 1 0 00-1-1z",
    fill: props.color
  }));
}

export default SvgIconRoomSizeFilled;